// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.small-select[data-v-75899d6f] {\n  max-width: 225px;\n  font-size: 90%;\n}\n", ""]);
// Exports
module.exports = exports;
